import React, { useState } from "react";
import { Download } from "lucide-react";
import * as XLSX from "xlsx";
import { TspCard, TspToggleGroup, TspTable } from "../../../components/primitives";

const RANGE_OPTIONS = [
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" },
];

// `stateWise` = { monthly, yearly } — the toggle actually switches the rows
// shown (previously it only redrew the same list under a different label).

export default function StateWiseDistributionTable({ stateWise }) {
  const [range, setRange] = useState("yearly");
  const rows = stateWise?.[range] || [];

  const columns = [
    { key: "rank", label: "Rank" },
    { key: "state", label: "State Name" },
    { key: "books", label: "Books Distributed" },
    // Journeys with a city visit in the state in the same period (counted server-side).
    { key: "journeys", label: "Journey Count" },
  ];

  const handleDownload = () => {
    if (!rows || rows.length === 0) return;
    const exportData = rows.map((row) => ({
      Rank: row.rank,
      "State Name": row.state,
      "Books Distributed": row.books ?? 0,
      "Journey Count": row.journeys ?? 0,
    }));
    const sheet = XLSX.utils.json_to_sheet(exportData);
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, sheet, `State Wise (${range})`);
    const dateStr = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(book, `State-Wise-Book-Distribution-${range}-${dateStr}.xlsx`);
  };

  return (
    <TspCard
      title="State Wise Book Distribution"
      action={
        <div className="tsp-card-action-group">
          <button
            type="button"
            className="tsp-download-text-btn"
            onClick={handleDownload}
            disabled={rows.length === 0}
            title="Download Excel"
          >
            <Download size={14} /> Download
          </button>
          <TspToggleGroup options={RANGE_OPTIONS} value={range} onChange={setRange} />
        </div>
      }
    >
      {rows.length === 0 ? (
        <p className="tsp-muted-text">No books distributed {range === "monthly" ? "this month" : "this year"} yet.</p>
      ) : (
        <TspTable columns={columns} rows={rows} rowKey="rank" className="tsp-table-state-wise" />
      )}
    </TspCard>
  );
}
